<template>
  <Breadcrumbs
    title="Create Promotion"
    :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Promotions', path: '/promotions' },
      { label: 'Create Promotion', path: '/create-promotion' }
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <createPromotionForm />
    </div>
  </div>
</template>

<script>
import CreatePromotionForm from './create_promotion_form.vue'
export default {
  name: 'indexList',
  components: {
    createPromotionForm: CreatePromotionForm,
  },
}
</script>